import React, { useMemo } from 'react';
import useState2RM from '../../hooks/useState2ReduxMock';
import { useAppSelector, useAppDispatch } from '@web-common/state/createStore';
import Pagination from '@lingxi-common-component/sirius-ui/Pagination';
import { Thunks } from '@web-common/state/reducer/mailReducer';
import { getFilterCondParams } from '../../state/customize';
import { EnhanceSelect, InSingleOption } from '@lingxi-common-component/sirius-ui/Select';
import Styles from './realListPager.module.scss';
import { apiHolder as api, apis } from 'api';
const mailConfApi = api.api.requireLogicalApi(apis.mailConfApiImpl);
const MailRealListPager = props => {
    const { hideOnSinglePage = false, simple = false, hidePaginationItem = false, style = {}, showCustomPageSelect = false, hideQuickJumper = false, size = 'normal', } = props;
    const totalCount = useAppSelector(state => state.mailReducer.mailTotal);
    const defaultPageSize = useAppSelector(state => state.mailReducer.realListDefaultPageSize);
    const pageSizesOptions = useAppSelector(state => state.mailReducer.realListPageSizes);
    const [currentPage, setCurrentPage] = useState2RM('realListCurrentPage', 'doUpdateRealListPage');
    const [currentPageSize, setCurrentPageSize] = useState2RM('realListCurrentPageSize', 'doUpdateRealListPageSize');
    const [mailSearching, _] = useState2RM('mailSearching', 'doUpdateMailSearching');
    const mailReducerState = useAppSelector(state => state.mailReducer);
    const dispatch = useAppDispatch();
    const handlePageSizeChange = (page, pageSize) => {
        let hasChanged = false;
        if (currentPage !== page || currentPageSize !== pageSize) {
            hasChanged = true;
        }
        let newPage = page;
        if (pageSize && currentPageSize !== pageSize) {
            const startIndex = (page - 1) * pageSize;
            if (startIndex >= totalCount) {
                const lastPage = Math.ceil(totalCount / pageSize);
                newPage = lastPage;
            }
        }
        if (newPage) {
            setCurrentPage({ page: newPage });
        }
        if (pageSize) {
            setCurrentPageSize({ pageSize: pageSize });
            mailConfApi.setMailRealListPageSize(pageSize);
        }
        if (hasChanged) {
            const startIndex = (newPage - 1) * (pageSize || currentPageSize);
            if (!mailSearching) {
                dispatch(Thunks.loadMailList({
                    startIndex: startIndex,
                    noCache: true,
                }));
            }
            else {
                if (mailSearching !== 'advanced') {
                    dispatch(Thunks.loadSearchMailList({
                        startIndex: startIndex,
                        noCache: true,
                    }));
                }
                else {
                    dispatch(Thunks.loadAdvanceSearchMailList({
                        startIndex: startIndex,
                        noCache: true,
                        filterCond: getFilterCondParams(mailReducerState),
                    }));
                }
            }
        }
    };
    const handleCustomPageChange = (value) => {
        handlePageSizeChange(value, currentPageSize);
    };
    const pageNum = useMemo(() => Math.ceil(totalCount / currentPageSize), [totalCount, currentPageSize]);
    const pageNumArr = useMemo(() => {
        let res = [];
        if (showCustomPageSelect) {
            for (let i = 1; i <= pageNum; ++i) {
                res.push(i);
            }
        }
        return res;
    }, [pageNum]);
    if (!totalCount) {
        return null;
    }
    if (hideOnSinglePage) {
        if (totalCount <= currentPageSize) {
            return null;
        }
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Pagination, { style: Object.assign({}, style), className: Styles.realListPager +
                (hidePaginationItem ? ' ' + Styles.hidePageItem : '') +
                (simple ? ' ' + Styles.simple : '') +
                (hideQuickJumper ? ' ' + Styles.hideQuickJumper : '') +
                (size == 'small' ? ' ' + Styles.miniSize : ''), hideOnSinglePage: hideOnSinglePage, simple: simple, showLessItems: true, pageSize: currentPageSize, current: currentPage, defaultPageSize: defaultPageSize, pageSizeOptions: pageSizesOptions, total: totalCount, responsive: true, onChange: handlePageSizeChange, size: size }),
        (hideOnSinglePage && pageNum <= 1) || size == 'small'
            ? null
            : showCustomPageSelect && (React.createElement(EnhanceSelect, { className: Styles.pageSelect, dropdownClassName: Styles.pageSeletcOption, value: currentPage, showSearch: true, showArrow: false, onChange: handleCustomPageChange, defaultValue: currentPage, size: "small", style: { minWidth: '50px', maxWidth: '100px', marginLeft: '8px' } }, pageNumArr.map(page => {
                return React.createElement(InSingleOption, { value: page }, page + '/' + pageNum);
            })))));
};
export default MailRealListPager;
